import ScheduleTreatmentTableModel from './model';
import { ReactComponent as Pill } from '../../../../images/pill.svg';
import { ReactComponent as Injectable } from '../../../../images/injectable.svg';
import { ScheduleTreatment, ScheduleTreatmentType } from '../../../../entities/ScheduleTreatment';

export type ScreduleTreatmentTableViewModelProps = {
  scheduleTreatment: ScheduleTreatment | null;
};
export default function ScheduleTreatmentTableViewModel({ scheduleTreatment }: ScreduleTreatmentTableViewModelProps) {
  const model = ScheduleTreatmentTableModel;

  const getTypeIcon = (treatmentType: ScheduleTreatmentType) => {
    switch (treatmentType) {
      case ScheduleTreatmentType.ORAL:
        return <Pill />;
      case ScheduleTreatmentType.INJECTABLE:
        return <Injectable />;
      default:
        return null;
    }
  };

  const hasTreatments = model.hasTreatments(scheduleTreatment);

  return {
    getPeriod: model.getPeriod,
    getTypeIcon,
    currentScheduleTreatment: scheduleTreatment ? scheduleTreatment : null,
    hasTreatments
  };
}
